import {loadEventContent} from "./timeline/event/loadEventContent"
import {loadStammtischContent} from "./timeline/stammtisch/loadStammtischContent"
import {loadBlogContent} from "./timeline/blog/loadBlogContent"
import {loadIdeasContent} from "./timeline/ideas/loadIdeasContent";
import {loadSurveyContent} from "./survey/loadSurveyContent";
import {checkIfAlreadyFavourites} from "./favourites/checkIfAlreadyFavourites";
import {checkIfAlreadyFilled} from "./utils/checkIfAlreadyFilled";
import {stickyTab} from "./utils/stickyTab";
import {scrollTab} from "./utils/scrollTab";
import {enableSmilies} from "./utils/enableSmilies";
import {checkLive} from "./utils/checkLive";
import {stickyBanner} from "./utils/stickyBanner";
import {animateCounts} from "./utils/animateCounts";
import {animateResultLine} from "./utils/animateResultLine";
import {itemCardActiveTabs} from "./utils/itemCardActiveTabs";
import {sortItemlist} from "./utils/sortItemlist";
import {makeTall} from "./utils/makeTall";
import {makeTall2} from "./utils/makeTall2";
import {makeTall3} from "./utils/makeTall3";
import {makeShort} from "./utils/makeShort";
import {makeShort2} from "./utils/makeShort2";
import {makeShort3} from "./utils/makeShort3";
import {shop_brand_info} from "./utils/shop_brand_info";
import {hide_brand_info} from "./utils/hide_brand_info";
import {excludeModal} from "./modal/excludeModal";
import {decorateDateString} from "./utils/decorateDateString.js";
import {getAuthor} from "./author/getAuthor.js";
import {stringToDate} from "./utils/stringToDate.js";
import {getMonthNameFromNumber} from "./utils/getMonthNameFromNumber.js";
import {addImpression} from "./utils/addImpression.js";
import {lazyLoadFunction} from "./utils/lazyLoadFunction.js";
import {redirectToLogin} from "./utils/redirectToLogin.js";
import {addClick} from "./utils/addClick.js";
import {addToFavourites} from "./favourites/addToFavourites.js";
import {hostnameFromURL} from "./utils/hostnameFromURL.js";
import {initShare} from "./share/initShare";
import {initComments} from "./comments/initComments";
import {submitCodeForCodeAction} from "./points/submitCodeForCodeAction";
import {openShippingCountryModal} from "./modal/openShippingCountryModal";
import {initProst} from "./prost/initProst";
import {checkIfAlreadyProsted} from "./prost/checkIfAlreadyProsted";
import {initAuthor} from "./author/initAuthor";
import {initPointsForm} from "./points/initPointsForm";
import {initCookieBanner} from "./general/cookieBanner";
import {initSurvey} from "./survey/initSurvey";
import {initObserveNotLoadedImages} from "./utils/observeNotLoadedImages";
import {initToggleMore} from "./utils/toggleMore";
import {initAjaxFilter} from "./timeline/ajax-filter";
import {checkForRewards} from "./rewards/checkForRewards";
import {initMobileNavigationSlot} from "./general/mobileNavigationSlot";
import {initStickyHeader} from "./general/stickyHeader";
import {initScrollTopButton} from "./general/scrollTopButton";
import {initFortunewheel} from "./fortunewheel/fortunewheel";

window.loadStammtischContent = loadStammtischContent;
window.loadBlogContent = loadBlogContent;
window.loadEventContent = loadEventContent;
window.loadIdeasContent = loadIdeasContent;
window.loadSurveyContent = loadSurveyContent;
window.checkIfAlreadyFavourites = checkIfAlreadyFavourites;
window.checkIfAlreadyProsted = checkIfAlreadyProsted;
window.checkIfAlreadyFilled = checkIfAlreadyFilled;
window.enableSmilies = enableSmilies;
window.decorateDateString = decorateDateString;
window.getAuthor = getAuthor;
window.stringToDate = stringToDate;
window.getMonthNameFromNumber = getMonthNameFromNumber;
window.addImpression = addImpression;
window.hostnameFromURL = hostnameFromURL;
window.checkForRewards = checkForRewards;
window.initFortunewheel = initFortunewheel;
window.addEventListener("load", (event) => {
    const selectElement= document.querySelector('.single_dim');
    if(selectElement){
        selectElement.addEventListener('change', (event) => {
            window.location.href =event.target.value;
        });
    }
    initStickyHeader();
    initScrollTopButton();
    initMobileNavigationSlot();
    initAjaxFilter();
    initCookieBanner();
    initShare();
    initComments();
    initProst();
    initAuthor();
    initPointsForm();
    initSurvey();
    initObserveNotLoadedImages();
    initToggleMore();

});
window.expandMagicZoom=function expandMagicZoom(el,id) {
    const fullSrc = el.getAttribute('data-full');

    // Find the hidden anchor in the MagicZoom container that matches this image
    const galleryAnchor = document.querySelector(`.imagesMagic a.MagicZoom[href="${fullSrc}"]`);
console.log(galleryAnchor);
    if (galleryAnchor) {
        MagicZoom.expand(galleryAnchor);
    } else {
        console.warn("MagicZoom anchor not found for", fullSrc);
    }
}
$.fn.isInViewport = function () {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();
    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();
    return elementBottom > viewportTop && elementTop < viewportBottom;
};

jQuery.fn.shake = function () {
    this.each(function (i) {
        $(this).css({"position": "relative"});
        for (var x = 1; x <= 3; x++) {
            $(this).animate({left: -25}, 10).animate({left: 0}, 50).animate({left: 25}, 10).animate({left: 0}, 50);
        }
    });
    return this;
}

$(document).ready(function () {
    $(".missing_data_cta").shake();
    animateCounts();
    if (typeof activeMenuPoint !== "undefined" && typeof siteCode !== "undefined") {
        if (activeMenuPoint !== "") {
            $('.stammtisch_post_menu').find("." + activeMenuPoint).addClass("active");
        }
        animateResultLine();
        //position active satate header menu
        var pathname = window.location.pathname;
        var baseLink = "/" + siteCode + "/" + mainLanguageCode + "/";
        var menuContainer = $("#header_2");
        if (pathname.indexOf("stammtisch") >= 0) {
            menuContainer.find("a[href='" + baseLink + "stammtisch/']").parent().addClass("active");
        } else if (pathname.indexOf("blog") >= 0) {
            menuContainer.find("a[href='" + baseLink + "blog/']").parent().addClass("active");
        } else if (pathname.indexOf("umfragen") >= 0) {
            menuContainer.find("a[href='" + baseLink + "umfragen/']").parent().addClass("active");
        } else if (pathname.indexOf("veranstaltungen") >= 0) {
            menuContainer.find("a[href='" + baseLink + "veranstaltungen/']").parent().addClass("active");
        } else if (pathname.indexOf("ideenwerkstatt") >= 0) {
            menuContainer.find("a[href='" + baseLink + "ideenwerkstatt/']").parent().addClass("active");
        }
    }
});

$(document).on('click', '.reward', function () {
    var reward = $(this);
    reward.addClass('hover');
    setTimeout(function () {
        reward.tooltip('hide');
        reward.removeClass('hover');
    }, 2000);
});





$(document).on("keypress", "input", function (e) {
    if (e.which == 13) {
        var target = $(e.target);
        if (target.hasClass("code_action_input")) {
            submitCodeForCodeAction(target);
        }
    }
});


$(document).on("click", ".add_to_favourites", function (e) {
    e.preventDefault();
    if (shopUserId !== "") {
        var container = $(this).closest(".timeline_entry");
        var id = container.attr("id");
        if (id !== undefined) {
            var favouriteContainer = $(".timeline_entry#" + id).find(".add_to_favourites");
            if (favouriteContainer.hasClass("active")) {
                removeFromFavourites(id);
            } else {
                addToFavourites(id);
            }
        }
    } else {
        redirectToLogin();
    }
});


$(document).on("click", ".imageCheckbox", function (e) {
    e.preventDefault();
    var container = $(this).closest(".timeline_entry");
    var type = container.attr("data-type");
    if (parseInt(type) === 1) { // Einfachantwort
        container.find("input[type='radio']").prop("checked", false);
        container.find(".form-radio-label.imageCheckbox").removeClass("active");
        $(this).find("input[type='radio']").prop("checked", true);
        $(this).toggleClass('active');
    } else { // Mehrfachantwort
        $(this).toggleClass('active');
        $(this).find("input[type='checkbox']").prop("checked", true);
    }
});

$(window).scroll(function () {
    lazyLoadFunction();
});

$('window').on('touchmove', function (event) {
    lazyLoadFunction();
});


$(document).on("click", "#timeline_check_icon", function (e) {
    e.preventDefault();
    submitCodeForCodeAction($(e.target));
});

$(document).on("click", ".redeem_code", function (e) {
    e.preventDefault();
    var code = $(this).closest(".collection_points").find(".codename").text();
    var id = $(this).closest(".timeline_entry").attr("id");
    if (shopUserId !== "") {
        redeemCode(code, id);
    } else {
        redirectToLogin();
    }
});




$(document).on("click", "#read_more_button", function (e) {
    e.preventDefault();
    $("#read_more_button_container").remove();
    pageCount = 0;
    lazyLoadFunction();
});

// Count Clicks on Timeline Elements
$(document).on("click", `
    .timeline_entry.link a,
    .timeline_entry.social_media a,
    .timeline_entry.social_media .content.timeline_borderbox--small,
    .timeline_entry.social_media .content.timeline_borderbox--small a,
    .timeline_entry.images a,
    .timeline_entry.images .bigimages,
    .timeline_entry.images .smallimages div div,
    .timeline_entry.item a,
    .timeline_entry.collection_points a,
    .timeline_entry.collection_points .codebox_primary,
    .timeline_entry.code_action a,
    .timeline_entry.ransom_action a,
    .timeline_entry.blog_entry a,
    .timeline_entry.event_entry a,
    .timeline_entry.survey_entry a,
    .timeline_entry.ideas_entry a
`, function (e) {
    addClick($(this));
});


var countMagicZoom = 0;

//Select current Magiczoom images on click
$(document).on('click', '.bigimages, .smallimages > div,.imageGallery__image,.smallimagesCounter', function () {
    countMagicZoom = $(this).data('count');
});

var mzOptions = {};
mzOptions = {
    onExpandOpen: function () {
        var MagicZoomId = arguments[0];
        MagicZoom.switchTo(MagicZoomId, countMagicZoom);
    }
};
if (navigator.userAgent.indexOf('MSIE') != -1) {
    var detectIEregexp = /MSIE (\d+\.\d+);/ //test for MSIE x.x
} else { // if no "MSIE" string in userAgent
    var detectIEregexp = /Trident.*rv[ :]*(\d+\.\d+)/ //test for rv:x.x or rv x.x where Trident string exists

}
if (detectIEregexp.test(navigator.userAgent)) { //if some form of IE
    var ieversion = new Number(RegExp.$1) // capture x.x portion and store as a number
    if (ieversion <= 9) {
        $(function () {
            $('#input_search').val("Suche");
        });
    }

} else {
    if (window.matchMedia('(min-width: 768px) and (max-width: 991px)').matches) {
        $(function () {
            $('#input_search').val("Suche");
        });

    } else {

    }

}
$(window).on('load', function () {

    +(function ($) {

        "use strict";

        // initialize
        var $window = $(window);
        var $document = $(document);
        var open = false;
        var breakpointSmallDevices = 0; // has to be 768 in production! Should match the bootstrap breakpoint value
        var toggle = '[data-toggle="dropdown"]';
        var bsEventName = 'click.bs.dropdown.data-api';
        var $navbar = $('.navbar-nav');
        var bsDropdown = $.fn.dropdown.Constructor;
        var bsClickHandler = bsDropdown.prototype.toggle;

        // events
        $navbar.on('touchstart click mouseenter mouseleave', '.dropdown', dropdownHandler);

        function dropdownHandler(evt) {
            var isMobile = parseInt($window.width()) < breakpointSmallDevices;

            // default behavior on mobile
            if (isMobile) {
                return true;
            }

            // remove focus
            if (evt.type === 'mouseleave') {
                $navbar.find(':focus').blur();
            }

            // trigger link
            var $target = $(evt.target);

            if ($target.attr('href') && ((open && evt.type === 'click') || evt.type === 'touchstart')) {
                window.location.assign($target.attr('href'));

                return true;
            }

            // prevent default behavior and update status
            evt.preventDefault();
            open = evt.type === 'mouseenter';

            // trigger bootstrap event
            $(this).find(toggle).trigger(bsEventName);

            // switch event handling
            if (open) {
                $document.off(bsEventName, toggle, bsClickHandler);
            } else {
                $document.on(bsEventName, toggle, bsClickHandler);
            }

            return false;
        }
    })(window.jQuery);
});

$(document).ready(function () {
    // Mobile navigation
    let mobileNavigationToggle = document.querySelector('.navbar-toggle');
    let mobileNavigationMenu = document.querySelector('.mobileNavigation');
    let htmlBody = document.querySelector('body');

    stickyBanner();
    itemCardActiveTabs();

    if (mobileNavigationToggle) {
        mobileNavigationToggle.addEventListener('click', function () {
            mobileNavigationToggle.classList.toggle('active');

            if (mobileNavigationMenu) {
                mobileNavigationMenu.classList.toggle('active');
            }

            if (htmlBody) {
                htmlBody.classList.toggle('hideOverflow');
            }
        })
    }

    var attr_length = $('.card_attributes').children('select').length;

    if (attr_length == 2 || attr_length == 4) {
        $('.card_attributes').children('select').css("width", "48%");
    } else {
        $('.card_attributes').children('select').css("width", "97%");
        $('.card_attributes').children().children('.form-control').css("width", "97%");
        $('.button_item_cell').css("width", "50%");
    }
    if ($('.preview_only_1 .itemcard_list12.owl-carousel').length) {

        $('.preview_only_1 .itemcard_list12.owl-carousel').owlCarousel({
            margin: 10,
            nav: true,
            autoplay: true,
            loop: true,
            responsiveClass: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            items: 1
        })
    } else {

        $('.itemcard_list12.owl-carousel').owlCarousel({
            margin: 10,
            nav: true,
            autoplay: true,
            loop: true,
            responsiveClass: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            responsive: {
                0: {
                    items: 1
                },
                480: {
                    items: 2
                },
                768: {
                    items: 3
                },
                1200: {
                    items: 4
                },
                1400: {
                    items: 5
                }
            }
        })
    }

    //MAB 29.4.16 Neusortierung der Itemlist wegen 2 3 oder 4 spaltigen Special Collections
    if ($(window).width() > 767) {
        sortItemlist(".itemcard_list2");
    }

    $(window).on("orientationchange", function (event) {
        if ($(window).width() > 767) {
            sortItemlist(".itemcard_list2");
        }
    });

    $("#header_2 ul.level_1").on("click", "li.level_2", function () {
        var a_href = $(this).find("a").attr("href");
        window.location = a_href;
    });


    $("#item_img_gallery01").justifiedGallery({
        rowHeight: 200,
        lastRow: "nojustify",
        margins: 10

    });

    $("#gallery_shop_salzburg").justifiedGallery({
        rowHeight: 200,
        lastRow: "nojustify",
        margins: 10,
        captions: false
    });
    $("#gallery_shop_wien").justifiedGallery({
        rowHeight: 200,
        lastRow: "nojustify",
        margins: 10,
        captions: false
    });

    $("#gallery_braushop").justifiedGallery({
        rowHeight: 200,
        lastRow: "nojustify",
        margins: 10,
        captions: false
    });


    //Karten Artikelliste ---
    $(".special_collection .special_collection_default a.next").click(function () {
        var card = $(this).parent().parent();
        var to = ".special_collection_content";
        changeSite(card, to);
    });


    //Karten Artikelliste +++

    $("#inlineContent_comment .upload_user_img_default a.next").click(function () {
        var card = $(this).parent().parent();
        var to = ".upload_user_img_form";
        changeSite2(card, to);
    });


    $(".collection_list.bier-lexikon .special_collection_default a.next").click(function () {
        var card = $(this).parent().parent().parent();
        var to = ".special_collection_content";
        changeSite3(card, to);
    });


    //Hoverintent
    $("ul.navbar-nav li.dropdown").hoverIntent(makeTall, makeShort);
    $(".header-basket, .shopping_bag").hoverIntent(makeTall2, makeShort2, 'div.shopping_bag');
    $("#gadget_1").hoverIntent(makeTall3, makeShort3);
    $("#brands_info").hoverIntent(shop_brand_info, hide_brand_info);

    /*
    $("ul.navbar-nav li.dropdown").hover(function() {
              $(this).find("ul.dropdown-menu.level_2").stop(true, true).delay(200).fadeIn();

            }, function() {
              $(this).find("ul.dropdown-menu.level_2").stop(true, true).delay(200).fadeOut();
            });
    */


    $(".wk_inactive").click(function (event) {
        event.preventDefault();
    });

    $(".itemcard_list2 select.form-control").change(function () {
        var counter_id = $(this).attr('counter_id');
        $("select[counter_id='" + counter_id + "'] option:selected").each(function () {
            if ($(this).hasClass('inactive')) {
                $("#add_to_basket[counter_id='" + counter_id + "']").addClass('inactive');
                $("#add_to_basket[counter_id='" + counter_id + "']").addClass('wk_inactive');
                $("#add_to_basket[counter_id='" + counter_id + "']").attr('type', 'button');
                $("#add_to_basket[counter_id='" + counter_id + "']").parent().parent().addClass('inactive');
                $("#add_to_basket[counter_id='" + counter_id + "']").parent().parent().removeClass('active');
            } else {
                $("#add_to_basket[counter_id='" + counter_id + "']").removeClass('inactive');
                $("#add_to_basket[counter_id='" + counter_id + "']").removeClass('wk_inactive');
                $("#add_to_basket[counter_id='" + counter_id + "']").attr('type', 'submit');
                $("#add_to_basket[counter_id='" + counter_id + "']").parent().parent().addClass('active');
                $("#add_to_basket[counter_id='" + counter_id + "']").parent().parent().removeClass('inactive');
            }
        });
    }).change();


    $('select#input_country').change(function () {
        // if the invoice country is a third-country dont allow shipping to a different country
        var shipping_select = $('select#input_shop_country_shipping');
        update_shipping_country_select($(this), shipping_select);
        $('select#input_shop_country_shipping option[value="' + $(this).val() + '"]').prop('selected', true);
    });

    function update_shipping_country_select(input_select, shipping_select) {
        var is_third_country = $(input_select).find(':selected').data('third_country');
        if (is_third_country) {
            // show all countries and disable the select
            shipping_select.find('option').each(function (index) {
                $(this).show();
            });
            shipping_select.prop('disabled', 'disabled');
        } else {
            // disable all third countries as shipping_country, by hide the option
            shipping_select.prop('disabled', false);
            shipping_select.find('option').each(function (index) {
                if ($(this).data('third_country') == true) {
                    // && $(this).is(':selected')==false
                    $(this).hide();
                }
            });
        }
    }

    // execute at first, to disable the select if necessary
    update_shipping_country_select($('select#input_country'), $('select#input_shop_country_shipping'));


    $('.slidecontent').find('.slidecontent_content_container').hide().end().find('.slidecontent_headline').click(function () {
        var currClass = $(this).attr('class').split(' ')[0];
        $(this).toggleClass(currClass + '_open');
        $(this).next().slideToggle('fast');
    });


});


//function makeTall(){$(this).find("ul.dropdown-menu.level_2").css("display", "block");}

$(document).on('change', '.btn-file :file', function () {
    var input = $(this),
        numFiles = input.get(0).files ? input.get(0).files.length : 1,
        label = input.val().replace(/\\/g, '/').replace(/.*\//, '');
    input.trigger('fileselect', [numFiles, label]);
});

$(document).ready(function () {
    $('.btn-file :file').on('fileselect', function (event, numFiles, label) {

        var input = $(this).parents('.input-group').find(':text'),
            log = numFiles > 1 ? numFiles + ' files selected' : label;

        if (input.length) {
            input.val(log);
        } else {
            if (log) alert(log);
        }

    });
});


$(document).ready(function () {

    $('.component.newsletter_teaser .textcontent').click(function () {
        self.location.href = '/freundeskreis/at/info/newsletter/';
        return false;
    });

    $('#closemodal1').click(function () {
        $('.success').hide();
        return false;
    });

    $('#closemodal2').click(function () {
        $('.error').hide();
        return false;
    });


});

$(document).ready(function () {
    /*$(document).on("click", ".tabItem", function(e) {
        if(!$(this).hasClass('inactive')){
            var curTabID = $(this).data('tab-id');
            $(this).closest('.ideaTabs').find('.ideaTab').hide();
            $(this).closest('.ideaTabs').find('.tabItem').removeClass('active');
            $(this).addClass('active');
            $("#" + curTabID).show();
        }
        e.preventDefault();
    });*/

    var selects = $('.card_attributes').find('select'),
        inList = ($('.itembox .itemcard_list2').length > 0);
    if (selects.length > 0) {
        $(selects).each(function () {
            var sel = $(this),
                options = $(this).children('option');
            if ($(sel).hasClass('single-dim')) {
                $(sel).on('change', function () {
                    var valEncoded = this.value,
                        valDecoded = decodeURIComponent(valEncoded);
                    console.log("here 1");
                    //   window.location.href = valDecoded;
                });
            } else if ($(sel).hasClass('multi-dim') && !inList) {
                $(sel).on('change', function () {
                    var sel = this,
                        valEncoded = this.value,
                        valDecoded = decodeURIComponent(valEncoded);
                    console.log("here 2");
                    //    window.location.href = sel.options[this.selectedIndex].value;
                });
            }
        });
    }


    // +++ MAB 16022017 Sticky Tabs
    if ($('#sticky-tab').length > 0) {
        $('.itemcard_tabs ul.tab > li').click(function (event) {
            scrollTab($(this).children('a').attr('href'));

            event.preventDefault();
        })

        var offsetStickyTab = $('#sticky-tab').offset().top;

        stickyTab();
        $(window).scroll(stickyTab);
    }
    // --- MAB 16022017 Sticky Tabs

    if ($('#form_user_order').length > 0) {
        $('#form_user_order input').each(function () {
            var valueInput = $.trim($(this).val());
            if ($(this).val() != "") {
                $(this).addClass('is_checked');
            }
        });
        $("#form_user_order input").change(function () {
            var valueInput = $.trim($(this).val());
            if ($(this).val() != "") {
                $(this).addClass('is_checked');
            } else {
                $(this).removeClass('is_checked');
            }
        });
    }

});


// +++ PS 23.11.2018 (VP7):
// For live nickname and slug validation
var nicknameCheckTimeoutId;
var slugCheckTimeoutId;
var oldNick;
var oldSlug;
$(document).ready(function () {
    oldNick = $('#input_community_nickname').val();
    oldSlug = $('#input_community_nickname_slug').val();

    $('#input_community_nickname').on("change paste keyup", function () {
        $(this).removeClass("text_error");
        $(this).parent().tooltip("hide");
        $(this).parent().tooltip("disable");

        window.clearTimeout(nicknameCheckTimeoutId);

        var newval = $(this).val().trim();
        if (newval.length == 0) {
            $(this).removeClass("text");
            $(this).removeClass("text_success");
            $(this).addClass("text_error");
            return;
        }
        if (oldNick != newval) {
            nicknameCheckTimeoutId = window.setTimeout(checkLive, 350, "nickname", $(this));
        } else {
            $(this).removeClass("text_error");
            $(this).removeClass("text_success");
            $(this).addClass("text");
        }
    }).parent().tooltip("disable");


    $('#input_community_nickname_slug').on("change paste keyup", function () {
        $(this).removeClass("text_error");
        $(this).tooltip("hide");
        $(this).tooltip("disable");

        window.clearTimeout(nicknameCheckTimeoutId);

        var newval = $(this).val().trim();
        if (newval.length == 0) {
            $(this).removeClass("text");
            $(this).removeClass("text_success");
            $(this).addClass("text_error");
            return;
        }
        if (oldSlug != newval) {
            nicknameCheckTimeoutId = window.setTimeout(checkLive, 350, "nickname_slug", $(this));
        } else {
            $(this).removeClass("text_error");
            $(this).removeClass("text_success");
            $(this).addClass("text");
        }
    }).tooltip("disable");
});

// Helper function for ajax call after timeout

// --- PS 23.11.2018


$(document).ready(function () {
    $('.js-showSelectCountry').on('click', function (e) {
        openShippingCountryModal();
    });

    $(".js-countrySearch").on('focus', function () {
        var containerCountry = $(".containerCountry");
        containerCountry.addClass("active");
    });

    $(".js-countrySearch").on('focusout', function () {
        var containerCountry = $(".containerCountry");
        containerCountry.removeClass("active");
    });

    $(".js-countrySearch").on('keyup', function () {
        var selectCountry = $($("ul").data($('#listCountry')));
        if (selectCountry.length > 0) {
            var val = $(this).val().toLowerCase();
            selectCountry.find(".itemCountry").each(function () {
                if ($(this).text().toLowerCase().indexOf(val) != -1) {
                    $(this).closest('.itemCountry').show();
                } else {
                    $(this).closest('.itemCountry').hide();
                }
            });
        }
    });

    $('.js-itemCountry').on('click', function () {
        var thisClick = $(this);
        var allItems = $(".itemCountry");
        var countryCode = $(this).attr("data-country-code");
        var countrySelect = $("#selectCountry select");
        allItems.removeClass("active");
        thisClick.addClass("active");
        countrySelect.val(countryCode);
    });
});

$(document).ready(function () {
    $('.form-control').on('change', function () {
        var id = $(this).children(':selected').data('item-id');
        var counter = $(this).attr('counter_id');
        if (id) {
            $('#input_item_id_' + counter).val(id);
        }
    });
});

$(document).ready(function () {
    $('.text-replace').each(function () {
        var currEl = this,
            defaultText = $(currEl).data('defaulttext');
        $(currEl).on('focus', function () {
            var currText = $(this).val();
            if (currText.length > 0 && currText == defaultText) {
                $(currEl).val('');
            }
        });
        $(currEl).on('blur', function () {
            var currText = $(this).val();
            if (!(currText.length > 0)) {
                $(currEl).val(defaultText);
            }
        });
    });
});

jQuery.event.special.touchstart = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchstart", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.touchmove = {
    setup: function (_, ns, handle) {
        this.addEventListener("touchmove", handle, {passive: !ns.includes("noPreventDefault")});
    }
};
jQuery.event.special.wheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("wheel", handle, {passive: true});
    }
};
jQuery.event.special.mousewheel = {
    setup: function (_, ns, handle) {
        this.addEventListener("mousewheel", handle, {passive: true});
    }
};

window.addEventListener('load', function () {
    excludeModal();

    document.querySelectorAll('.js-ajax-filter').forEach(function (element) {
        element.addEventListener('click', function (event) {

        });
    });
})